export default __webpack_public_path__ + "static/media/auteuil.36783923.jpg";